// extracted by mini-css-extract-plugin
export default {"employee-container":"Department_employee-container__os7S0"};